import { HTMLAttributes } from "react";
import RawSvgFile from "../../../public/media/stacklogos/nodejs-logo.svg";

export const NodejsLogo = (props: HTMLAttributes<SVGElement>): JSX.Element => {
  return <RawSvgFile {...props} />;
};
